const __WEBPACK_NAMESPACE_OBJECT__ = require("@ssa-ui-kit/utils");